import type {
  TypedAmountSpec,
  TypedAmountTypeOption,
} from "../typedAmountTypes";

const NOT_INCLUDED: TypedAmountTypeOption = {
  value: "notIncluded",
  label: "Not Included",
  hideAmount: true,
};
const NOT_OFFERED: TypedAmountTypeOption = {
  value: "notOffered",
  label: "Not Offered",
  hideAmount: true,
};

const RATE_GUARANTEE_OPTIONS: TypedAmountTypeOption[] = [
  { value: "months", label: "Months" },
  { value: "years", label: "Years" },
  NOT_INCLUDED,
  NOT_OFFERED,
];

export const dentalHmoTypedAmountFields: Record<string, TypedAmountSpec> = {
  rateGuarantee: {
    typeKey: "rateGuaranteeType",
    amountKey: "rateGuaranteeAmount",
    amountLabel: "Amount",
    typeOptions: RATE_GUARANTEE_OPTIONS,
    amountMin: 1,
    amountInteger: true,
    textExtra: {
      key: "rateGuaranteeCap",
      label: "Cap",
      maxLength: 1024,
    },
  },
};
